var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _polygon2, _polygon3, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _circle3, _path16, _path17, _path18, _path19, _circle4, _path20, _path21, _rect, _rect2, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawDataExtractionRe0Rd3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 843.31696,
    height: 590.96051,
    viewBox: "0 0 843.31696 590.96051",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.84183,663.77549c3.3177-26.67814,19.85136-52.96384,45.29423-61.64564a123.86334,123.86334,0,0,0,.00613,85.04048c3.90959,10.57529,9.35914,21.9305,5.68165,32.58879-2.28809,6.6319-7.88558,11.70587-14.14246,14.8785-6.25726,3.17262-13.20152,4.68476-20.05886,6.16664l-1.34957,1.11616C229.387,717.33942,221.52412,690.45362,224.84183,663.77549Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M270.38853,602.6343a105.86975,105.86975,0,0,0-26.31905,59.58345,45.59123,45.59123,0,0,0,.5186,14.27515,26.14861,26.14861,0,0,0,6.50347,12.12824c2.93126,3.22058,6.30257,6.17542,8.39991,10.05246a16.01086,16.01086,0,0,1,.78221,13.07063c-1.85174,5.31109-5.5014,9.64009-9.21759,13.74945-4.12611,4.56267-8.48414,9.23648-10.23805,15.28536-.21251.73291-1.33731.36031-1.12512-.37149,3.05151-10.524,13.26755-16.50187,18.13956-25.98072,2.27337-4.423,3.22758-9.55792,1.09633-14.22686-1.86368-4.08278-5.3376-7.13282-8.33374-10.36807A27.90262,27.90262,0,0,1,243.79421,678.21a42.1481,42.1481,0,0,1-1.06551-14.20255,102.71271,102.71271,0,0,1,7.50152-31.21348,107.74726,107.74726,0,0,1,19.37431-31.04834c.5066-.56729,1.2873.32506.784.88865Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.38841,655.04738a15.88384,15.88384,0,0,1-12.09073-16.6389c.06037-.76,1.24414-.70185,1.18369.05912a14.70807,14.70807,0,0,0,11.27854,15.45466c.74174.17635.366,1.30046-.3715,1.12512Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.39022,687.18393a30.61482,30.61482,0,0,0,13.67134-17.63188c.2151-.73213,1.34-.35975,1.12512.37149a31.844,31.844,0,0,1-14.26357,18.31865c-.657.38973-1.18634-.67065-.53289-1.05826Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.96983,622.5379a8.991,8.991,0,0,0,8.52045-.43252c.65175-.39787,1.1804.663.53289,1.05826a10.07516,10.07516,0,0,1-9.42483.49938.61234.61234,0,0,1-.37682-.74831.59544.59544,0,0,1,.74831-.37681Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M347.68951,649.78024c-.3999.26-.79981.52-1.2002.79a118.40687,118.40687,0,0,0-15.13965,11.81995c-.37011.33-.74023.67-1.10009,1.01a124.82725,124.82725,0,0,0-27.10987,37.11,121.22331,121.22331,0,0,0-6.64013,17.18c-2.4502,8.13-4.46,17.14-9.31006,23.79a20.79633,20.79633,0,0,1-1.62012,2H241.73931c-.09961-.05-.1997-.09-.2998-.14l-1.75.08c.07031-.31.1499-.63.22021-.94.04-.18.08985-.36.12989-.54.02978-.12.06-.24.08007-.35.00977-.04.02-.08.02979-.11.02-.11.05029-.21.07031-.31q.65991-2.685,1.35987-5.37c0-.01,0-.01.00976-.02,3.59033-13.63,8.3501-27.08,15-39.38.2002-.37.3999-.75.62012-1.12a115.674,115.674,0,0,1,10.39013-15.76,102.26444,102.26444,0,0,1,6.81006-7.79,85.037,85.037,0,0,1,21.27979-15.94c15.72021-8.3,33.91992-11.48,50.72021-6.41C346.83941,649.51028,347.25982,649.64023,347.68951,649.78024Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M347.591,650.33654a105.86972,105.86972,0,0,0-56.88764,31.72816,45.59132,45.59132,0,0,0-8.18056,11.71014,26.14871,26.14871,0,0,0-2.10938,13.59926c.40144,4.33627,1.31422,8.72531.65458,13.08366a16.0108,16.0108,0,0,1-7.24487,10.9071c-4.67615,3.12574-10.19656,4.38485-15.63784,5.42855-6.04151,1.15883-12.33511,2.26677-17.37736,6.04049-.61094.45724-1.28469-.51747-.67468-.974,8.77265-6.56562,20.52866-5.18784,30.12561-9.82289,4.47812-2.16279,8.33157-5.68823,9.44091-10.69927.97007-4.38194.03268-8.90877-.41173-13.29582a27.90246,27.90246,0,0,1,1.56708-13.374,42.14774,42.14774,0,0,1,7.70016-11.98146,102.71229,102.71229,0,0,1,24.78222-20.40578A107.74717,107.74717,0,0,1,347.5,649.155c.746-.14794.83213,1.03459.091,1.18156Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.275,676.53158a15.88383,15.88383,0,0,1,.364-20.56469c.50575-.57043,1.41593.18868.90951.75987a14.70809,14.70809,0,0,0-.29949,19.13014c.48607.58739-.49073,1.25871-.974.67468Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.92028,705.20225a30.61484,30.61484,0,0,0,21.53141-5.847c.61253-.45506,1.28647.51951.67468.974a31.844,31.844,0,0,1-22.41775,6.03876c-.75925-.08439-.54346-1.24974.21166-1.1658Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M324.0951,657.54739a8.991,8.991,0,0,0,7.06351,4.78455c.75993.07473.54332,1.24-.21166,1.16581a10.07521,10.07521,0,0,1-7.82587-5.27568.61234.61234,0,0,1,.14967-.82434.59543.59543,0,0,1,.82435.14966Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "812.114 307.961 671.114 307.961 671.114 305.961 810.114 305.961 810.114 212.961 812.114 212.961 812.114 307.961",
    fill: "#e4e4e4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.114 346.961 353.114 346.961 353.114 251.961 494.114 251.961 494.114 253.961 355.114 253.961 355.114 346.961",
    fill: "#e4e4e4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "561.114 134.961 420.114 134.961 420.114 39.961 422.114 39.961 422.114 132.961 561.114 132.961 561.114 134.961",
    fill: "#e4e4e4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "a6516cba-8069-4f45-b641-c1f90dba684f-302",
    "data-name": "Path 680",
    d: "M570.39852,154.51974a2.85519,2.85519,0,0,0,0,5.71037h57.91875a2.85519,2.85519,0,0,0,0-5.71037Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "a2f9acfe-22a3-4ed4-9cf2-7606b61419d8-303",
    "data-name": "Path 681",
    d: "M570.39852,171.34155a2.85518,2.85518,0,0,0,0,5.71037h57.91875a2.85519,2.85519,0,0,0,0-5.71037Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "ec202844-6974-4039-9753-1a4628c4214d-304",
    "data-name": "Path 683",
    d: "M1018.8033,354.6936a2.85519,2.85519,0,0,0,0-5.71037H960.87845a2.85519,2.85519,0,1,0,0,5.71037Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "e7621fd2-cc0e-4ef1-8ca7-425f7b24c113-305",
    "data-name": "Path 684",
    d: "M1018.8033,337.87006a2.85519,2.85519,0,0,0,0-5.71037H960.87845a2.85519,2.85519,0,1,0,0,5.71037Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M773.45569,490.48026a107,107,0,1,1,107-107A107.12118,107.12118,0,0,1,773.45569,490.48026Zm0-212a105,105,0,1,0,105,105A105.119,105.119,0,0,0,773.45569,278.48026Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#e4e4e4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 552.11417,
    cy: 134.96051,
    r: 12,
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.11417,
    cy: 253.96051,
    r: 12,
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 667.11417,
    cy: 307.96051,
    r: 12,
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "bc1eae62-5e4d-4f76-aab9-42af61f239ce-306",
    "data-name": "Path 683",
    d: "M503.10809,514.26691a2.85518,2.85518,0,1,0,0,5.71037h57.92485a2.85519,2.85519,0,0,0,0-5.71037Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "ace38b77-7629-49a8-ba58-07c8d3bba8b5-307",
    "data-name": "Path 684",
    d: "M503.10809,531.09045a2.85519,2.85519,0,1,0,0,5.71037h57.92485a2.85519,2.85519,0,0,0,0-5.71037Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M360.23274,744.91247H345.67792a6.91067,6.91067,0,0,1-6.90292-6.90291V616.70149a6.91068,6.91068,0,0,1,6.90292-6.90292h14.55482a6.91068,6.91068,0,0,1,6.90292,6.90292V738.00956A6.91067,6.91067,0,0,1,360.23274,744.91247Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#6c63ff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M398.88156,744.91247H384.3265a6.91067,6.91067,0,0,1-6.90292-6.90291V616.70149a6.91068,6.91068,0,0,1,6.90292-6.90292h14.55506a6.91068,6.91068,0,0,1,6.90292,6.90292V738.00956A6.91067,6.91067,0,0,1,398.88156,744.91247Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.35917,
    cy: 278.88085,
    r: 50.29268,
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M390.772,652.81468h-36.1806a42.67686,42.67686,0,0,1-37.0395-64.15436l50.59771-87.63757a6.40982,6.40982,0,0,1,11.10216,0l49.57884,85.87284A43.94635,43.94635,0,0,1,390.772,652.81468Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M385.57127,454.51261c3.26-.09052,7.31737-.20368,10.44309-2.487a8.02,8.02,0,0,0,3.15569-5.98853,5.39494,5.39494,0,0,0-1.83455-4.43083c-1.63256-1.37954-4.01651-1.70311-6.5856-.94811l2.66178-19.452-1.954-.26772-3.12921,22.86832,1.63171-.74874c1.89173-.86768,4.48851-1.30923,6.10217.05441a3.4664,3.4664,0,0,1,1.13672,2.85535,6.0616,6.0616,0,0,1-2.3482,4.465c-2.43246,1.77677-5.66652,2.006-9.33454,2.10853Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 224.73345,
    y: 268.36397,
    width: 10.62221,
    height: 1.97226,
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 191.205,
    y: 268.36397,
    width: 10.62221,
    height: 1.97226,
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M361.87132,641.56626a6.84449,6.84449,0,0,1-.66147-2.81118l-2.47938-90.33657a14.18017,14.18017,0,0,1,28.35364-.61639l2.47895,90.33678a6.91025,6.91025,0,0,1-6.75066,7.05146l-14.55122.31624a6.9192,6.9192,0,0,1-6.38986-3.94034Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#6c63ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M369.03445,396.22389c6.11043,7.991,15.81068,13.35154,26.06283,12.0823,9.763-1.20867,17.81727-8.01348,19.838-17.75577a29.25827,29.25827,0,0,0-7.68852-25.82727c-6.91028-7.2681-16.8-11.17783-26.58914-12.5185-18.54366-2.53964-37.58855,3.99238-51.60934,16.17482a63.221,63.221,0,0,0-16.461,22.06481A61.85336,61.85336,0,0,0,307.484,417.1464c.53875,18.12014,8.47578,36.20559,22.17089,48.22263a62.49968,62.49968,0,0,0,5.33307,4.177c1.56191,1.09571,3.04187-1.468,1.49316-2.55449-14.02472-9.83866-22.97056-25.84741-25.42579-42.66835a59.09282,59.09282,0,0,1,13.85788-47.66929c11.32483-12.87686,27.92989-21.24647,45.12811-21.99639,17.30555-.75459,38.93161,6.97139,42.17,26.23537,1.45149,8.63438-1.776,17.71019-9.68829,22.03293-8.47138,4.62817-18.85892,2.72352-26.139-3.25369a30.02551,30.02551,0,0,1-4.79514-4.94141c-1.141-1.49215-3.71167-.02017-2.55449,1.49315Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M560.34152,745.48026h-381a1,1,0,1,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-178.34152 -154.51974)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawDataExtractionRe0Rd3);
export default __webpack_public_path__ + "static/media/undraw_data_extraction_re_0rd3.ac28de59b508d75c835fde448967512b.svg";
export { ForwardRef as ReactComponent };